@let canAdd = fileAddAllowed();
@let assets = store.entities();

<div class="asset-handler">
  <div class="gallery">
    @for (asset of assets; track asset.id) {
    <div class="image">

      @if (asset.status === 'loading') {
      <kt-simple-preloader></kt-simple-preloader>
      }

      @else {


      @if (!asset.extension) {
      <mat-icon>attachment</mat-icon>
      }
      @else {
      @if (['jpg', 'jpeg', 'png'].includes(asset.extension)) {

      <img class="image__preview"
           width="100px"
           height="100px"
           [src]="asset.url | safe:'resourceUrl'"
           alt="Image">

      }

      @else {
      <mat-icon>description</mat-icon>
      }
      }

      }


      <div class="image__remove"
           (click)="removeFile(asset.id)">

        <kt-generic-button tooltipMessage="Remove image"
                           appearance="icon"
                           color="black"
                           (click)="removeFile(asset.id)">delete</kt-generic-button>
      </div>

    </div>
    }
  </div>

  @if(canAdd) {
  <div class="upload"
       fileDragDrop
       (fileDropped)="addFiles($event)">
    <span>Drag and drop images here or </span>
    <a [style.cursor]="'pointer'"
       [style.color]="'blue'"
       [style.padding-left.px]="5"
       (click)="fileInput.click()">browse</a>
  </div>
  }
</div>

<input #fileInput
       type="file"
       name="file"
       [multiple]="multiple()"
       [accept]="store.accept()"
       hidden
       (change)="addFiles($any(fileInput.files))" />
